import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {palette} from '@/styles';
import Icon from './warning.svg';

export const ErrorBox = () => (
  <Root>
    <img src={Icon} width={64} height={64} alt={'warning'} />
    <Typography variant="bold16" color={palette.gray800} align="center">
      분석할 수 없는 도형입니다.
    </Typography>
    <Typography variant="medium14" color={palette.gray600} align="center">
      선과 선이 겹치지 않게 그려주세요.
    </Typography>
  </Root>
);

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  background-color: ${palette.white};
  padding-bottom: 24px;
  border-radius: 5px;
`;
